import * as z from 'zod';
import * as ba from './base';
import { assertVueComponent } from '../helpers';
export class ReloadSlickgridAction extends ba.Action {
    static get manifest() {
        return {
            name: 'reloadSlickgrid',
            schema: z.object({
                grid: z.union([z.string(), z.array(z.string())])
            })
        };
    }
    async handle(event, args) {
        assertVueComponent(event.component);
        event.component.$root.$emit('slickgrid:reload', args);
    }
}
//# sourceMappingURL=slickgrid.js.map